import gql from 'graphql-tag';
import Utils from '../../helpers/utils';

const { secureVariables } = Utils();

export default ({ query, variables }) => {
  query = gql`
    query route($url: String!) {
      route(url: $url) {
        type
        ... on ProductInterface {
          sku
        }
        ... on CategoryTree {
          uid
        }
        ... on CmsPage {
          identifier
          redirect_code
          relative_url
        }
        ... on CategoryInterface {
          uid
        }
      }
    }
  `;

  secureVariables(variables);

  return { query, variables };
};

